import { reportError } from '~/utils/errorReporter';

const GMAP_GENERIC_FAILURE_MSG = 'There was a problem obtaining address information. Please try again.';
const GMAP_LOAD_ERROR_MESSAGE = 'There was problem a loading Google Maps. Please reload the page.';
const GMAP_LOAD_ERROR_NAME = 'Google Maps Load Error';

export default {
  computed: {
    google: () => window.google,
  },
  methods: {
    /**
     * Helper function to get the address data from a marker's
     * position/coordinates.
     */
    getAddressFromMarker(marker) {
      if (!this.google) {
        return this.createGmapError();
      }

      const geocoder = new this.google.maps.Geocoder();
      let position = marker.position;

      if (!position) {
        position = {
          lat: parseFloat(marker.latitude),
          lng: parseFloat(marker.longitude),
        };
      }

      return new Promise((resolve) => {
        geocoder.geocode({ location: position }, (results, status) => {
          if (status !== this.google.maps.GeocoderStatus.OK) {
            reportError(`Geocoder error, status: ${status}`, { context: { position, results } });
            this.$appMessage(GMAP_GENERIC_FAILURE_MSG);

            return resolve(null);
          }

          if (!results || !results.length) {
            this.$appMessage(GMAP_GENERIC_FAILURE_MSG);

            return resolve(null);
          }

          const [result] = results;

          return resolve(result);
        });
      });
    },
    /**
     * Helper function to get the information of a Google Maps Place ID.
     * Sometimes the user might click on a POI marker in the map. With this
     * function we get the information necessary to render the address and
     * some other useful fields.
     */
    getPlaceFromId(placeId) {
      if (!this.google) {
        return this.createGmapApiError();
      }

      const fakeMap = document.createElement('div');
      const placer = new this.google.maps.places.PlacesService(fakeMap);

      return new Promise((resolve) => {
        placer.getDetails({ placeId }, (response, status) => {
          if (status !== 'OK') {
            reportError(`Bad place response, status: ${status}, placeId: ${placeId}`, {
              context: { placeId, response },
            });

            return resolve(null);
          }

          return resolve(response);
        });
      });
    },
    createGmapError() {
      this.$appMessage(GMAP_LOAD_ERROR_MESSAGE);

      return Promise.reject(new Error(GMAP_LOAD_ERROR_NAME));
    },
  },
};
